// utils
import apiSlice from "src/utils/api-slice";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    createStore: "/store/create",
    createShoplazzaStore: "/store/create_logout",
    editStore: "/store/edit",
    deleteStore: "/store/delete",
    preStore: "/store/pre_url",
    postStore: "/store/finish_auth",
    reAuthStore: "/store/reauth",
    //
    stores: "/store/query_all",
    storeOptions: "/order/store_drop_down"
};

const {
    useGetStoreListQuery,
    useGetStoreOptionsQuery,
    //
    useLazyPreStoreQuery,
    useAddStoreMutation,
    useAddShoplazzaStoreMutation,
    usePostStoreMutation,
    useReAuthStoreMutation,
    //
    useUpdateStoreMutation,
    //
    useDeleteStoreMutation
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getStoreList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "StoreList" ],
            query: () => `${ API_ENDPOINTS.stores }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        getStoreOptions: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "StoreOptions" ],
            query: () => `${ API_ENDPOINTS.storeOptions }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        //
        preStore: builder.query({
            query: ({ platform }) => `${ API_ENDPOINTS.preStore }?platform=${ platform }`,
            transformResponse: ({ data }, meta, arg) => {
                if (data) {
                    localStorage.setItem("ssAuthStore", JSON.stringify(arg));
                    //
                    window.open(data, "_self", "noopener,noreferrer");
                }

                return data;
            }
        }),
        addStore: builder.mutation({
            query: ({ skipWindowOpen, ...request }) => ( {
                url: `${ API_ENDPOINTS.createStore }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, { skipWindowOpen, ...arg }) => {
                if (data && !skipWindowOpen) {
                    localStorage.setItem("ssAuthStore", JSON.stringify(arg));

                    window.open(data, "_self", "noopener,noreferrer");
                }

                return data;
            },
            invalidatesTags: [ "StoreList", "StoreOptions" ] // 触发数据更新
        }),
        addShoplazzaStore: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.createShoplazzaStore }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, arg) => {
                if (data) {
                    localStorage.setItem("ssAuthStore", JSON.stringify({
                        ...arg,
                        ...( data?.temp_session_id && { temp_session_id: data.temp_session_id } )
                    }));
                    //
                    if (data?.redirect_url) window.open(data.redirect_url, "_self", "noopener,noreferrer");
                }

                return data?.redirect_url;
            },
            invalidatesTags: [ "StoreList", "StoreOptions" ] // 触发数据更新
        }),
        postStore: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.postStore }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "StoreList", "StoreOptions" ] // 触发数据更新
        }),
        reAuthStore: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.reAuthStore }`,
                method: "POST",
                body: request
            } ),
            transformResponse: ({ data }, meta, arg) => {
                if (data) {
                    localStorage.setItem("ssAuthStore", JSON.stringify(arg));
                    //
                    window.open(data, "_self", "noopener,noreferrer");
                }

                return data;
            },
            invalidatesTags: [ "StoreList", "StoreOptions" ] // 触发数据更新
        }),
        updateStore: builder.mutation({
            query: (store) => ( {
                url: `${ API_ENDPOINTS.editStore }`,
                method: "POST",
                body: store
            } ),
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "StoreList", "StoreOptions" ] // 触发数据更新
        }),
        deleteStore: builder.mutation({
            query: (id) => ( {
                url: `${ API_ENDPOINTS.deleteStore }`,
                method: "POST",
                body: {
                    store_id: id
                }
            } ),
            invalidatesTags: [ "StoreList", "StoreOptions" ] // 触发数据更新
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetStoreListQuery,
    useGetStoreOptionsQuery,
    //
    useLazyPreStoreQuery,
    useAddStoreMutation,
    useAddShoplazzaStoreMutation,
    usePostStoreMutation,
    useReAuthStoreMutation,
    //
    useUpdateStoreMutation,
    //
    useDeleteStoreMutation
};
